import { render, staticRenderFns } from "./PUDetailsKpis.vue?vue&type=template&id=00627820&scoped=true"
import script from "./PUDetailsKpis.vue?vue&type=script&lang=js"
export * from "./PUDetailsKpis.vue?vue&type=script&lang=js"
import style0 from "./PUDetailsKpis.vue?vue&type=style&index=0&id=00627820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00627820",
  null
  
)

export default component.exports